import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {Alert} from 'Components/Partials';
import {Input, Textarea, FormHandler} from 'Components/Form';
import BookingApi from 'Services/Api/Exhibitor/Booking';
import {translation} from 'Services/TranslationHelpers';
import {timeToTwelveHour} from 'Services/DateHelpers';
import DarkButton from "Components/Button/DarkButton";
import { ModalTrigger } from "Components/Modal";
import UpdateBookingItem from "Pages/Exhibitors/UpdateBookingItem";
import { PrimaryButton } from "Components/Button/index";
import Book from "Pages/Exhibitors/Book";

class ViewBookings extends React.Component {
    state = {
        selectedBookingItem: null,
    };

    success = translation('exhibitors', 'successful_booking');

    request = (form) => {
        return BookingApi.post(null, {
            ...form,
            exhibitor_booking_item_id: this.state.selectedBookingItem.id
        });
    };

    handleBookingClick = (item) => {
        this.setState({ selectedBookingItem: item });
    };

    render () {
        const {form, handleSubmit, handleInput, active_booking_items, alert, working, exhibitor, editing} = this.props;
        const {selectedBookingItem} = this.state;

        return (
            <Modal className={"bg-app-light-green text-white"}>
                <ModalHeader onClose={this.props.onClose} className="border-none text-white" titleClassName="text-white">
                    {translation('exhibitors', 'submit_your_booking')}
                </ModalHeader>

                <form onSubmit={e => handleSubmit(e, this.request, this.success, true)}>
                    <ModalBody className="border-0">
                        {alert && (<Alert {...alert} />)}
                        <div className="flex flex-row my-3 p-4 w-full gap-5">
                        {active_booking_items.map((item, i) => (
                            <div key={ i }>
                                <div
                                    className={`flex my-3 hover:bg-app-blue hover:text-white rounded cursor-pointer  w-20 max-w-full max-w-20 ${selectedBookingItem && selectedBookingItem.id === item.id ? 'bg-app-blue text-white' : 'bg-white text-app-blue '}`}
                                    onClick={ () => this.handleBookingClick ( item ) }
                                >
                                    <div className="flex-1 justify-center items-center text-sm px-6 py-2">
                                        { timeToTwelveHour(item.start_date_time.time_timezone) }
                                    </div>
                                </div>
                                {editing && (
                                    <ModalTrigger
                                        component={UpdateBookingItem}
                                        props={{
                                            exhibitor: exhibitor,
                                            bookingItem: item,
                                            submitCallback: this.props.onClose
                                        }}
                                    >
                                        <PrimaryButton
                                            text="Update"
                                            onClick={() => null}
                                            className="uppercase"
                                    />
                                </ModalTrigger>
                                )}
                            </div>
                        ) ) }
                        </div>
                        { selectedBookingItem && (
                            <div className="mt-4">
                                <Input
                                    containerClassName="mb-4"
                                    label={ translation ( 'auth_frontend', 'name' ) }
                                    value={ form.name ?? '' }
                                    error={ this.props.getFieldError ( 'name' ) }
                                    onChange={ v => handleInput ( 'name', v ) }
                                />

                                <Input
                                    containerClassName="mb-4"
                                    label={ translation ( 'auth_frontend', 'email' ) }
                                    value={ form.email ?? '' }
                                    error={ this.props.getFieldError ( 'email' ) }
                                    onChange={ v => handleInput ( 'email', v ) }
                                />

                                <Textarea
                                    containerClassName="mb-4"
                                    label={ translation ( 'exhibitors', 'message' ) }
                                    value={ form.message ?? '' }
                                    error={ this.props.getFieldError ( 'message' ) }
                                    onChange={ v => handleInput ( 'message', v ) }
                                />
                            </div>
                        ) }
                    </ModalBody>

                    <ModalFooter
                        alignment="center"
                        className="bg-transparent"
                    >
                        <DarkButton
                            text={ translation ( 'misc', 'close' ) }
                            onClick={ this.props.onClose}
                            className="mr-2"
                        />
                        <DarkButton
                            className="ml-2"
                            text={translation('misc', 'submit')}
                            disabled={working || !selectedBookingItem}
                            working={working}
                        />
                    </ModalFooter>
                </form>
            </Modal>
        );
    }
}
export default FormHandler(ViewBookings);
